import { withProps } from 'astroturf/helpers';
import Link from './Link';
/**
 * A `Link` component that injects an `active` prop to the link Component.
 * Useful for Bootstrap components such as the `NavItem` or `MenuItem`
 */

const ActiveLink = withProps(({
  active
}) => ({
  activePropName: active == null ? 'active' : null
}))(Link);
/** @component */

export default ActiveLink;